export const PAGE_TYPE_GENDER = 'gender';
export const PAGE_TYPE_AGE = 'age';

/** 指标文案映射（后端返回的 metric -> 前端展示文案） */
export const maleMap = {
  male: 'Male',
  female: 'Female',
} as any;

/** data.ai（appannie）年龄段 */
export const appannieAgeMap = {
  lt25: '< 25',
  gte25: '>= 25', // 大于等于25
  gte25_lte34: '25 - 34',
  gte35_lte44: '35 - 44',
  gte25_lte44: '25 - 44',
  gt44: '> 44',
} as any;

/** SensorTower 年龄段 */
export const sensortowerAgeMap = {
  '<25': '<25',
  '25-34': '25-34',
  '35-44': '35-44',
  '45-54': '45-54',
  '55+': '55+',
} as any;

/** 年龄段-文本映射（汇总） */
export const ageMap = {
  ...appannieAgeMap,
  ...sensortowerAgeMap,
} as any;

export const cardMetricMap = {
  ...maleMap,
  ...ageMap,
};

/** 年龄段展示顺序（按数据源） */
export const ST_AGE_ORDER = ['<25', '25-34', '35-44', '45-54', '55+'];
export const APPANNIE_AGE_ORDER_4 = ['lt25', 'gte25_lte34', 'gte35_lte44', 'gt44'];
export const APPANNIE_AGE_ORDER_3 = ['lt25', 'gte25_lte44', 'gt44'];

export const SOURCE_LIST = {
  SENSORTOWER: 'sensortower',
  APPANNIE: 'appannie',
  LIFETIME :'lifetime',
  QUARTERLY :'quarterly'
};
